import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getCookieConsent, setCookieConsent, track } from "@/lib/api";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getCookieConsent()) setVisible(true);
    const onChange = (e) => { if (!e.detail) setVisible(true); };
    window.addEventListener("z-cookie-consent", onChange);
    return () => window.removeEventListener("z-cookie-consent", onChange);
  }, []);

  const choose = (v) => {
    setCookieConsent(v);
    setVisible(false);
    if (v === "accepted") track("visit", "", window.location.pathname);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[60] bg-ink-2/95 backdrop-blur-md border-t border-gold/30"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-5 flex flex-col md:flex-row md:items-center gap-5">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="w-6 h-6 text-gold shrink-0 mt-0.5" />
          <p className="text-white/70 text-sm leading-relaxed">
            Používame nevyhnutné cookies pre chod stránky a — s vaším súhlasom — analytické cookies
            na meranie návštevnosti a zlepšovanie obsahu. Viac v{" "}
            <Link to="/pouzivanie-cookies" className="text-gold hover:text-gold-light underline">zásadách používania cookies</Link>.
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={() => choose("rejected")}
            data-testid="cookie-reject-btn"
            className="px-6 py-3 border border-white/25 text-white/80 font-bold uppercase tracking-wider text-xs hover:border-white/50 transition-colors"
          >
            Odmietnuť
          </button>
          <button
            onClick={() => choose("accepted")}
            data-testid="cookie-accept-btn"
            className="px-6 py-3 bg-gold text-ink font-bold uppercase tracking-wider text-xs hover:bg-gold-light transition-colors"
          >
            Prijať všetky
          </button>
        </div>
      </div>
    </div>
  );
}
